<template>
  <div>
    <x-grid :id="'roleTableList'"
            :rowId="rowId"
            :pager-config="pagerConfig"
            :url="url"
            :other-params="{
              'filter.eq.custId':mainRowId
            }"
            :columns="columns"
            :cell-click="chooseRow"
            @returnForm="returnForm"
            ref="grid"
    >
    </x-grid>
  </div>
</template>

<script>
import XGrid from '@/components/grid/XGridPop'
import {GridPopMixin} from "@/utils/GridPopMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"
import api from '@/services/api'

const fac = XGrid.factory;
console.info(fmt);//防止不使用便利 eslint报错


//列表接口
const url = api.client.SHARE;
//主键
const rowId = 'sourceId';
//方法表名 和表单中 方法判断名称一致
const tableName = 'roleTable';
//表格需要多选还是单选
const tableType = 'checkbox';

//列
const columns = [
  // fac.makeColumnDefault(tableType),
  fac.makeColumn("custCustName", "客户姓名", 120,"center"),
  fac.makeColumn("custTelephone", "手机号", 120,"center"),
  fac.makeColumn("shareUserName", "共享人", 120,"center"),
  fac.makeColumn("shareMobile", "共享人电话", 120,"center"),
  fac.makeColumn("createDate", "添加时间", 120,"center"),
  // fac.makeColumn("isSystem", "是否是系统角色", 140, 'center', true, fmt.formatYesNo),
  fac.makeColumn("remark", "备注", 120,"center"),
]

const pagerConfig = fac.makePagerConfig();

export default {
  mixins:[GridPopMixin],
  props:['mainRowId'],
  data() {
    return {
      tableType,
      tableName,
      columns,
      rowId,
      url,
      pagerConfig,
    }
  },
}
</script>

<style scoped>
</style>